import { Button, Typography } from '@mui/material';
import { HeaderContent } from '../../types/reports';

interface Props extends NonNullable<HeaderContent['action']> {
  isLoading?: boolean;
}

function TableAction({ isLoading, disabled, label, icon, onClick }: Props) {
  return (
    <Button
      disabled={isLoading || disabled}
      variant="light"
      className="virtualized-table-action-button"
      style={{
        borderRadius: '10px',
      }}
      startIcon={icon}
      onClick={onClick}>
      <Typography variant="body2">{label}</Typography>
    </Button>
  );
}

export default TableAction;
